import { getAsyncActions, put } from 'core/middlewares/utilities';
import { Bff } from 'core/services';
import { getUnixtime } from 'core/utilities';

import { requestHandler } from './request-handler';

import type { RequestAction } from '../@types';

/**
 * Middleware responsible for handle BFF requests.
 *
 */
export function* bffRequest(action: RequestAction) {
  const { payload, type } = action;
  const asyncAction = getAsyncActions<typeof type>(type);

  try {
    const data: Bff.BffResponse = yield requestHandler(action);

    if (data?.success === false) {
      yield put({
        type: asyncAction.failure,
        error: '',
        meta: {
          payload,
          response: data,
        },
      });

      return;
    }

    yield put({
      type: asyncAction.success,
      payload: data,
      meta: { updatedAt: getUnixtime(), payload },
    });
  } catch (error) {
    yield put({
      type: asyncAction.failure,
      error,
      meta: {
        payload,
      },
    });
  }
}
